import { VisionLinkFooterProp } from '../types';

export const VisionLinkFooter = ({ children }: Readonly<VisionLinkFooterProp>) => {
  return (
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-2 mt-md-3">
      {children}
    </div>
  );
};
